import {LtvGradationTypeExtended} from '@wallex-core-client/core/interfaces/credits.interface';
import {IMeterColors} from '@wallex-core-client/core/interfaces/meter.interface';

export const ltvGradationColorMap = new Map<LtvGradationTypeExtended, IMeterColors>([
  [LtvGradationTypeExtended.low, {activeColor: '#2AAC66', inactiveColor: '#C1C0C0'}],
  [LtvGradationTypeExtended.medium, {activeColor: '#F7D20D', inactiveColor: '#979797'}],
  [LtvGradationTypeExtended.high, {activeColor: '#F08302', inactiveColor: '#626266'}],
  [LtvGradationTypeExtended.liquidation, {activeColor: '#CC3030', inactiveColor: '#1A1A1D'}]
]);
